import { Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import './SignUp.css'
import { useDispatch } from 'react-redux'
import { setPassword } from 'redux/actions/'
import { useState } from 'react'

export default function Login() {
  const dispatch = useDispatch()
  const [Warning, setWarning] = useState(false)
  const [password, setpassword] = useState({
    pass: '',
    confirm: ''
  })
  useEffect(() => {
    if (password.pass === '' || password.confirm === '') {
      dispatch(setPassword({ password: '', match: false }))
      setWarning(false)
    } else if (
      password.pass === password.confirm &&
      password.confirm.length > 0
    ) {
      dispatch(setPassword({ password: password.confirm, match: true }))
      setWarning(false)
    } else {
      setWarning(true)
      dispatch(setPassword({ password: '', match: false }))
    }
    // eslint-disable-next-line
  }, [password])
  return (
    <>
      <Typography variant="h2" align="center" style={{ padding: '25px 0' }}>
        Please choose a password
      </Typography>
      <label>Password</label>
      <input
        placeholder="********"
        type="password"
        onChange={e => setpassword({ ...password, pass: e.target.value })}
      />
      <label>Confirm Password</label>
      <input
        placeholder="*********"
        type="password"
        onChange={e => setpassword({ ...password, confirm: e.target.value })}
      />
      {Warning && (
        <Typography
          variant="caption"
          align="center"
          style={{ color: 'red', margin: '-14px auto 25px', display: 'block' }}>
          the password does not match!
        </Typography>
      )}
    </>
  )
}
